/**
 * Mid-Round Transition Screen.
 * Shown when all cards are guessed mid-turn.
 * Informs the player of the new round's rules and lets them resume with saved time.
 */

import { getState, getCurrentCardReader, resumeTurnAfterMidRound } from '../game-state';
import { RoundNumber } from '../../shared/types';
import { navigate } from '../router';
import { t, getRoundName, getRoundDesc } from '../i18n';

export function renderMidRoundTransition(): void {
  const app = document.getElementById('app')!;
  const state = getState();
  const round = state.currentRound;
  const cardReader = getCurrentCardReader();

  const minutes = Math.floor(state.timerRemaining / 60);
  const seconds = state.timerRemaining % 60;
  const timeText = `${minutes}:${String(seconds).padStart(2, '0')}`;

  app.innerHTML = `
    <div class="round-interstitial">
      <p class="text-muted" style="margin-bottom: var(--space-sm);">${t('allCardsGuessed')}</p>

      <div class="round-number">${t('roundN', round)}</div>
      <div class="round-name">"${getRoundName(round)}"</div>
      <div class="round-description">${getRoundDesc(round)}</div>

      <div class="surface" style="margin-top: var(--space-lg); padding: var(--space-md);">
        <p class="text-secondary" style="font-size: var(--font-size-sm);">
          ${t('continuesWith', cardReader?.displayName || '')} <strong>${timeText}</strong> ${t('remaining')}
        </p>
      </div>

      <button class="btn btn-primary" id="btn-resume"
        style="margin-top: var(--space-xl); font-size: var(--font-size-xl); padding: var(--space-lg);">
        ${t('start')}
      </button>
    </div>
  `;

  document.getElementById('btn-resume')?.addEventListener('click', () => {
    resumeTurnAfterMidRound();
    navigate('turn-active');
  });
}
